import React from 'react'
import moment from 'moment'
import i18next from 'i18next'

import listingStyles from './styles/listing.scss'

export default class WopiListProfile extends React.Component {
  render() {
    const { questionnaire, isDeleted, onView, onDelete } = this.props

    return (
      <tr key={questionnaire.uuid} className={isDeleted && listingStyles.deleted}>
        <td>{moment(questionnaire.invitation.createdAt).format('dd l')}</td>

        {questionnaire.invitation.email && <td>{questionnaire.invitation.email}</td>}

        {!questionnaire.invitation.email && (
          <td className={listingStyles.linkCreated}>{i18next.t('link_created')}</td>
        )}

        <td>{questionnaire.invitation.organisation}</td>

        <td>{questionnaire.invitation.role}</td>

        <td>
          {!isDeleted && (
            <a href="#" onClick={onView}>
              {i18next.t('link_to_questionnaire')}
            </a>
          )}

          {!isDeleted && (
            <small>
              <a href="#" onClick={onDelete}>
                {i18next.t('delete')}
              </a>
            </small>
          )}

          {isDeleted && <span>{i18next.t('deleted')}</span>}
        </td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WopiListInvitation.js